export const DeclarationType = [
  { value: null, text: "Selecione o tipo de declaração", disabled: true  },
  {value : "INSS" , text: "INSS" },
  {value : "ISS" , text: "ISS" },
  {value : "LTCAT/PPP" , text: "LTCAT/PPP" },
];

